export const styles = {
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    gap: 15
  },
}
